// TODO: make this the useMedia (or useMediaQuery) hook in patterns for v5.X without the need of the shim - or pull from a third party library that employs similar API and external store sync
import { useCallback } from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
// ^ https://github.com/reactwg/react-18/discussions/86

export function useMedia (query) {
    const subscribe = useCallback((callback) => {
        const matchMedia = window.matchMedia(query);

        matchMedia.addEventListener('change', callback);
        return () => {
            matchMedia.removeEventListener('change', callback);
        };
    },
    [query]);

    const getSnapshot = () => {
        return window.matchMedia(query).matches;
    };

    const getServerSnapshot = () => {
        throw Error('useMedia is a client-only hook');
    };

    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export default useMedia;
